/*
 * Helpers for releases in src/data/songs.js.
 *
 * A single has one `preview`. An EP or album lists its songs in `tracks`
 * (each with its own title and preview), while the cover and streaming links
 * belong to the release as a whole.
 */

// Has a track list (EP/album)?
export const isCollection = (release) => Array.isArray(release.tracks) && release.tracks.length > 0;

// Every song in the release as { title, preview }; a single is a list of one
export const releaseTracks = (release) => {
  if (isCollection(release)) return release.tracks;
  return release.preview?.src ? [{ title: release.title, preview: release.preview }] : [];
};

// Only the songs that have a preview clip to play
export const playableTracks = (release) =>
  releaseTracks(release).filter((track) => track.preview?.src);

// "EP · 2026 · 4 tracks" (the track count only for EPs/albums)
export const releaseMeta = (release) => {
  const parts = [release.type, release.year];
  if (isCollection(release)) {
    const count = release.tracks.length;
    parts.push(`${count} ${count === 1 ? "track" : "tracks"}`);
  }
  return parts.filter(Boolean).join(" · ");
};
